import {
  ApolloClient,
  InMemoryCache
} from "@apollo/client";

export const client = new ApolloClient({
  uri: "https://api.graphql.jobs/",
  cache: new InMemoryCache(),
});
